import * as React from 'react';
import { SVGProps } from 'react';

const SvgExclamationTriangle = (
  props: SVGProps<SVGSVGElement> & React.HTMLAttributes<HTMLElement>
) => (
  <svg
    width={24}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 9h2v5.5h-2V9ZM12 18a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z"
      fill="#7B61FF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.866 2.18a1 1 0 0 0-1.732 0l-10 17.32A1 1 0 0 0 2 21h20a1 1 0 0 0 .866-1.5l-10-17.32ZM12 4.68 20.268 19H3.732L12 4.68Z"
      fill="#7B61FF"
    />
  </svg>
);
export default SvgExclamationTriangle;
